import styled from 'styled-components';
import media from "styled-query";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Content = styled.div`
  width: 1120px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 3rem 0;

  h1 {
    color: var(--secondary);
    margin-bottom: 3rem;
  }

  ${media.lessThan("1200px")`
    margin: 24px;
  `}

  ${media.lessThan("1023px")`
    margin: 24px;
    flex-direction: column;
    text-align: center;
  `}
`;

export const Images = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  ${media.lessThan("1023px")`
    margin: 24px;
    flex-direction: column;
  `}
`;